<form [formGroup]="benForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin">{{title}}</h1>
    <p class="lead rocal" style="margin-bottom: 0px;">{{subtitle}}</p>

    <!-- Panel 1: Beneficiary Info -->
    <ng-template #beneficiaryInfo let-i="index">
      <div *ngIf="getBensFormGroup(i)">
        <div class="line-section"></div>

        <div class="row"
          [ngClass]="{'half': getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'institution' || beneficiaries[i].personalDone}">
          <app-input [formGroup]="getBensFormGroup(i)" controlName="Category" *ngIf="!beneficiaries[i].personalDone"
            inputType="select" [selectFunction]="onBenTypeChange.bind(this)" [selectParam]="i"
            [ArrayItems]="BeneficiaryOptions" label={{benTypeLabel}} hint={{benTypeHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getBensFormGroup(i)" class="grid-item"
            *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'individual'" controlName="Relationship"
            inputType="select" [selectFunction]="onRelationshipChange.bind(this)" [selectParam]="i"
            [ArrayItems]="(hasSelfRelationship && i > selfRecords.length ? Relationships : RelationOptions)"
            label={{relationLabel}} hint={{relationHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

        <div class="row half" *ngIf="getBensFormGroup(i).get('Relationship')?.value === 'Other'">
          <app-input [formGroup]="getBensFormGroup(i)" controlName="Other" label='Specify Relationship'
            hint='Specify your relation to the settlor' [validationMessages]="validationMessages"
            [formErrors]="formErrors">
          </app-input>
        </div>

        <div *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'individual'">
          <div class="row-alt">
            <div class="row-mini">
              <app-input [formGroup]="getBensFormGroup(i)" controlName="Title" label={{titleLabel}} hint={{titleHint}}
                inputType="auto-complete" [loadingOptions]="loadingTitles" [ArrayItems]="TitleOptions" required="false"
                [validationMessages]="validationMessages" [formErrors]="formErrors">
              </app-input>

              <app-input [formGroup]="getBensFormGroup(i)" controlName="FirstName" label={{fNameLabel}}
                hint={{fNameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

            </div>
            <div class="row-mini">
              <app-input [formGroup]="getBensFormGroup(i)" controlName="MiddleName" label={{mNameLabel}}
                hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
              <app-input [formGroup]="getBensFormGroup(i)" controlName="LastName" label={{surnameLabel}}
                hint={{surnameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            </div>
          </div>

          <div class="row">
            <app-input [formGroup]="getBensFormGroup(i)" controlName="Phone" class="grid-item" label={{phoneLabel}}
              inputType="phone" required="false" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getBensFormGroup(i)" controlName="Email" class="grid-item" label={{emailLabel}}
              hint={{emailLabel}} required="false" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>

          <div class="row">
            <app-input [formGroup]="getBensFormGroup(i)" controlName="Gender" label={{genderLabel}} hint={{genderHint}}
              inputType="select" [ArrayItems]="GenderOptions" [validationMessages]="validationMessages"
              [formErrors]="formErrors">
            </app-input>
            <app-input [formGroup]="getBensFormGroup(i)" controlName="DOB" class="grid-item" label={{dobLabel}}
              hint={{dobHint}} [minDate]="minDate" [maxDate]="endDate" inputType="date"
              [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>
        </div>

        <div *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'institution'">
          <div class="row">
            <app-input [formGroup]="getBensFormGroup(i)" controlName="InstitutionName" class="grid-item"
              label={{institutionNameLabel}} hint={{institutionNameHint}} [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getBensFormGroup(i)" controlName="BusinessNature" label={{businessNatureLabel}}
              hint={{businessNatureHint}} inputType="select" [ArrayItems]="BusinessNatureOptions"
              [loadingOptions]="loadingBizNature" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>

          <div class="row">
            <app-input [formGroup]="getBensFormGroup(i)" controlName="OrgRegNum" class="grid-item"
              label={{orgRegNumLabel}} hint={{orgRegNumHint}} [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>

            <app-input [formGroup]="getBensFormGroup(i)" controlName="KraPin" class="grid-item"
              label="Institution KRA PIN" hint={{kraHint}} [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>
        </div>

        <div class="row"
          [ngClass]="{'half': (getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'individual' || !arrayContainsValue(getBensFormGroup(i).get('TrustPurpose')?.value, 'Other'))}">
          <app-input *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'institution'"
            [formGroup]="getBensFormGroup(i)" controlName="OrgAddress" class="grid-item" label={{orgAddressLabel}}
            hint={{orgAddressHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>

    <!-- Panel 2 (Institutions): Contact Info -->
    <ng-template #contactInfo let-i="index">
      <div *ngIf="getBens() && getBensFormGroup(i)">
        <div class="line-section"></div>

        <div formArrayName="ContactPersons" *ngIf="getContacts(i) && getContacts(i).controls">
          <div *ngFor="let contact of getContacts(i).controls; let j=index" [formGroupName]="j"
            style="position: relative;">
            <div *ngIf="getContacts(i) && getContactsFormGroup(i, j)">
              <div style="height: 50px;" *ngIf="j > 1"></div>

              <div class="line-2" *ngIf="j > 0"></div>

              <p style="font-weight: 600; font-size: 1.2em">
                {{'Contact Person ' + (j+1)}}
              </p>

              <div class="row-alt">
                <div class="row-mini">
                  <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="Title" label={{titleLabel}}
                    hint={{titleHint}} inputType="auto-complete" [loadingOptions]="loadingTitles"
                    [ArrayItems]="TitleOptions" required="false" [validationMessages]="validationMessages"
                    [formErrors]="formErrors">
                  </app-input>

                  <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="FirstName" label={{fNameLabel}}
                    hint={{fNameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

                </div>

                <div class="row-mini">
                  <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="MiddleName" label={{mNameLabel}}
                    hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
                    [formErrors]="formErrors"></app-input>
                  <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="LastName" label={{surnameLabel}}
                    hint={{surnameHint}} [validationMessages]="validationMessages"
                    [formErrors]="formErrors"></app-input>
                </div>

              </div>

              <div class="row">
                <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="Phone" class="grid-item"
                  label={{phoneLabel}} inputType="phone" [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
                <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="Email" class="grid-item"
                  label={{emailLabel}} hint={{emailLabel}} [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
              </div>

              <div class="remove-button" style="margin-top: 5px;" *ngIf="j > 0">
                <button mat-stroked-button type="button" (click)="removeContact(i, j)">
                  <div style="display: flex; flex: 1; align-items: center;">
                    <span class="button-text">
                      <u>{{ removeContactText }}</u>
                    </span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTTON Add Contact person -->
        <div class="blueStroke row" [ngClass]="{'min-55' : getContacts(i) && getContacts(i).length > 1}">
          <button mat-stroked-button [disabled]="!benForm.valid" type="button" (click)="addNewContact(i)">
            <span class="button-text">
              {{ '+ Add Contact Person' }}
            </span>
          </button>
        </div>
      </div>
    </ng-template>

    <!-- Panel 3: Upload Documents -->
    <ng-template #uploadDocs let-i="index">
      <div *ngIf="getBensFormGroup(i)">
        <div class="line-section"></div>

        <div *ngIf="getBensFormGroup(i) && getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'individual'">
          <div
            *ngIf="getBensFormGroup(i) && getBensFormGroup(i).get('DOB')?.value && getDateDifference(getBensFormGroup(i).get('DOB')?.value) === true">
            <div class="row">
              <app-input [formGroup]="getBensFormGroup(i)" class="grid-item" controlName="KraPinImage" [required]="region == 1 ? 'false' : 'true' "
                label={{kraFileLabel}} inputType="file" [fileFunction]="updateKraObject.bind(this, i)"
                [existingFileName]="beneficiaries[i]?.KraPinImage?.name != '' ? beneficiaries[i]?.KraPinImage?.name :
                                    getBensFormGroup(i).get('Relationship')?.value == 'Self' &&
                                    recordUpdate?.KraPinImage != '' ? recordUpdate?.KraPinImage?.name : ''"
                [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

              <app-input [formGroup]="getBensFormGroup(i)" controlName="IDNoImage"
                [fileFunction]="updateIDObject.bind(this, i)" [existingFileName]="beneficiaries[i]?.IDNoImage?.name != '' ? beneficiaries[i]?.IDNoImage?.name :
                                    getBensFormGroup(i).get('Relationship')?.value == 'Self' &&
                                    recordUpdate?.IDNoImage != '' ? recordUpdate?.IDNoImage?.name : ''"
                class="grid-item" label={{idFileLabel}} hint={{idHint}} inputType="file"
                [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            </div>
          </div>

          <div
            *ngIf="getBensFormGroup(i).get('DOB')?.value && getDateDifference(getBensFormGroup(i).get('DOB')?.value) === false">
            <div class="row half">
              <app-input [formGroup]="getBensFormGroup(i)" controlName="BirthCertImage"
                [fileFunction]="updateBirthCertObject.bind(this, i)"
                [existingFileName]="beneficiaries[i]?.BirthCertImage?.name != '' ? beneficiaries[i]?.BirthCertImage?.name : '' "
                class="grid-item" label={{birthCertLabel}} inputType="file" [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
            </div>
          </div>
        </div>

        <div *ngIf="getBensFormGroup(i).get('Category')?.value.toLowerCase() === 'institution'">
          <div class="row">
            <app-input [formGroup]="getBensFormGroup(i)" controlName="RegCertImage" class="grid-item"
              label={{regCertFileLabel}} inputType="file" [fileFunction]="updateRegCertObject.bind(this, i)"
              [existingFileName]="beneficiaries[i]?.RegCertImage?.name != '' ? beneficiaries[i]?.RegCertImage?.name : '' "
              [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getBensFormGroup(i)" class="grid-item" controlName="KraPinImage"
              [fileFunction]="updateKraObject.bind(this, i)"
              [existingFileName]="beneficiaries[i]?.KraPinImage?.name != '' ? beneficiaries[i]?.KraPinImage?.name : '' "
              label={{kraFileLabel}} inputType="file" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Panel 4: Guardian Information -->
    <ng-template #guardianInfo let-i="index">
      <form [formGroup]="guardianForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate *ngIf="
                    beneficiaries[i] && beneficiaries[i].personalDone
                    && getBensFormGroup(i).get('DOB')?.value
                    && getDateDifference(getBensFormGroup(i).get('DOB')?.value) === false">

        <p style="margin-top: 5px;">
          Any beneficiary who is a minor <strong>shall</strong> be required to have a guardian.
        </p>
        <div class="line-2"></div>

        <div formArrayName="guardians">
          <div *ngFor="let guardian of getGuardians().controls; let x=index" [formGroupName]="x"
            style="position: relative;">

            <div style="height: 40px;" *ngIf="x > 1"></div>

            <div class="flex" style="width: 100%; align-items: center; justify-content: center; margin-top: 40px;">
              <div class="flex brief" *ngIf="x === getGuardians().length-1 && suggestions === null && showSuggestHint"
                [@bounceIn]>
                If the Guardian is an existing Settlor, use the ID or First Name fields to search and autofill their
                details
              </div>
            </div>

            <div class="flex godolkin">
              <p class="flex brue margin" style="font-weight: 600; font-size: 1.3em;" *ngIf="getGuardians().length > 1">
                {{'Guardian ' + (x+1)}}
              </p>

              <div class="flex suggestions" *ngIf="x === getGuardians().length-1 && suggestions !== null" [@bounceIn]
                #suggestBox>
                <div class="flex suggest">
                  Autofill
                </div>

                <div class="flex sugg-holder">
                  <div [@slideInRight] *ngFor="let suggestion of suggestions; let s=index"
                    (click)="patchSuggestedValues(x, suggestion)" class="flex suggestion">
                    {{ suggestion.FirstName +' ' +suggestion.LastName }}
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="x == getGuardians().length-1">
              <div class="row half" *ngIf="x > 0">
                <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="Category" inputType="select"
                  [ArrayItems]="GuardianOptions" label={{guardianTypeLabel}} hint={{guardianTypeHint}}
                  [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
              </div>

              <div class="row-alt">
                <div class="row-mini">
                  <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="Title" label={{titleLabel}}
                    hint={{titleHint}} inputType="auto-complete" [loadingOptions]="loadingTitles"
                    [ArrayItems]="TitleOptions" required="false" [validationMessages]="validationMessages"
                    [formErrors]="formErrors">
                  </app-input>

                  <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="FirstName" label={{fNameLabel}}
                    hint={{fNameHint}} [runSuggestions]="true" [suggestFunction]="suggestSettlors.bind(this)"
                    [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

                </div>

                <div class="row-mini">
                  <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="MiddleName" label={{mNameLabel}}
                    hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
                    [formErrors]="formErrors"></app-input>
                  <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="LastName" label={{surnameLabel}}
                    hint={{surnameHint}} [validationMessages]="validationMessages"
                    [formErrors]="formErrors"></app-input>
                </div>

              </div>

              <div class="row">
                <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="Phone" class="grid-item"
                  label={{phoneLabel}} inputType="phone" [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
                <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="Email" class="grid-item"
                  label={{emailLabel}} hint={{emailLabel}} [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
              </div>

              <div class="row">
                <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="IDNo" class="grid-item" label={{idLabel}}
                  hint={{idHint}} [runSuggestions]="true" [suggestFunction]="suggestSettlors.bind(this)"
                  [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="KraPin" class="grid-item"
                  [required]="region == 1 ? 'false' : 'true' "
                  [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
                  label={{kraPinLabel}} hint={{kraHint}} [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
              </div>

              <p class="blue lead" style="margin-top: 40px; margin-bottom: 20px; margin-left: 14px;">
                {{'Upload Documents'}}
              </p>

              <div class="row">
                <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="IDNoImage"
                  [validationID]="getGuardiansFormGroup(x).get('IDNo')?.value"
                  [fileFunction]="updateGuardianIDObject.bind(this)"
                  [existingFileName]="idObjectGuardian && idObjectGuardian?.name ? idObjectGuardian?.name : ''"
                  class="grid-item" label={{idFileLabel}} inputType="file" [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
                <app-input [formGroup]="getGuardiansFormGroup(x)" controlName="KraPinImage"
                  [required]="region == 1 ? 'false' : 'true' "
                  [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
                  [validationID]="getGuardiansFormGroup(x).get('KraPin')?.value"
                  [fileFunction]="updateGuardianKraObject.bind(this)"
                  [existingFileName]="kraObjectGuardian && kraObjectGuardian?.name ? kraObjectGuardian?.name : ''"
                  class="grid-item" label={{kraFileLabel}} inputType="file" [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
              </div>

              <div class="line-2" style="margin-bottom: 20px; margin-top: 40px;" *ngIf="x > 0 || guardianForm.valid">
              </div>
            </div>

            <div *ngIf="x != getGuardians().length-1" class="flex done-box">
              <p class="light-blue lead">
                {{'Guardian ' + (x+1)}}
              </p>
              <div class="flex checker-circle">
                <img src={{checkerPath}} class="checker" alt="logo" />
              </div>
            </div>

            <div class="abs-view">
              <div class="remove-button-alt" *ngIf="x > 0 || getGuardians().length > 1">
                <button mat-stroked-button type="button" (click)="removeGuardian(x)">
                  <div style="display: flex; flex: 1; align-items: center;">
                    <span class="button-text">
                      <u>{{ 'Remove Guardian' }}</u>
                    </span>
                  </div>
                </button>
              </div>
            </div>

          </div>
        </div>

        <!-- BUTTTON Add Guardian -->
        <div class="blueStroke row" [ngClass]="{'min-55' : getGuardians().length > 1}">
          <button mat-stroked-button *ngIf="guardianForm.valid" [disabled]="loading || loadingRemove" type="button"
            (click)="addNewGuardian()">
            <span class="button-text">
              {{ '+ Add Another Guardian' }}
            </span>
          </button>
        </div>
      </form>
    </ng-template>

    <div formArrayName="beneficiaries">
      <div *ngFor="let ben of getBens().controls; let i=index; trackBy: trackByFn" [formGroupName]="i" style="position: relative;">
        <div style="height: 40px;" *ngIf="beneficiaries.length > 0"></div>

        <p style="font-weight: 600; font-size: 1.3em;" class="blue margin" *ngIf="i>0">
          {{'Beneficiary ' + (i+1)}}
        </p>

        <!-- Accordion -->
        <app-section [panels]="benPanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>
        <!-- ++++++++++++++++++++++++++++ -->

        <div class="action-buttons">
          <button mat-stroked-button type="button" class="remove" (click)="removeBen(i)"
            *ngIf="beneficiaries[i].personalDone || getBens().length > 1">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>{{
                  getBens().controls.length - 1 === i
                  ? removeButtonText
                  : removeBenText
                  }}</u>
              </span>
              <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                </mat-progress-spinner>
              </span>
            </div>
          </button>

          <button class="update" mat-stroked-button type="button" *ngIf="getBens() && !confirmFormMatchesRecord(i)"
            [disabled]="loading || loadingRemove" (click)="updateRecord(i)">
            <span class="button-text">
              {{ 'Update Beneficiary ' +(i+1) }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- BUTTTON Add Ben -->
    <div class="blueStroke row"
      [ngClass]="{'min-55' : getBens().length > 1 || beneficiaries[beneficiaries.length-1].done}"
    >
      <button mat-stroked-button
        *ngIf="beneficiaries[beneficiaries.length-1] && beneficiaries[beneficiaries.length-1].done" type="button"
        (click)="addNewBen()">
        <span class="button-text">
          {{ '+ Add New Beneficiary'}}
        </span>
      </button>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;" [service]="estateControlService" [formValid]="
            beneficiaries[beneficiaries.length-1].done === true ?
            true :
            (
                beneficiaries[beneficiaries.length-1].docsDone &&
                getBensFormGroup(getBens().length-1).get('DOB')?.value !== '' &&
                getDateDifference(getBensFormGroup(getBens().length-1).get('DOB')?.value) === false
            ) ?
            guardianForm.valid : benForm.valid
        "
    [showContinue]="benForm.pristine || benForm.valid || beneficiaries[beneficiaries.length-1].done ? 'true' : 'false'"
    [saveFunction]="updateProgress.bind(this)" [text]="
            loading ? loadingText :
            beneficiaries[beneficiaries.length-1].done ?
            'Next' :
            (
                beneficiaries[beneficiaries.length-1].docsDone &&
                getBensFormGroup(getBens().length-1).get('DOB')?.value !== '' &&
                getDateDifference(getBensFormGroup(getBens().length-1).get('DOB')?.value) === false
            ) ?
            'Save Guardian(s)' :
            beneficiaries[beneficiaries.length-1].contactsDone ? 'Upload Documents' :
            beneficiaries[beneficiaries.length-1].personalDone ? 'Update Details' : 'Save Details' "
    [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>